import { render, staticRenderFns } from "./WineShopComponent.vue?vue&type=template&id=637cf289&"
import script from "./WineShopComponent.vue?vue&type=script&lang=js&"
export * from "./WineShopComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports